import { ValidateTokenTranslation } from '../../types/validateToken.types';

export const validateToken: ValidateTokenTranslation = {
  title: 'Validating token...',
};

export default validateToken;
